import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modals: any[] = [];

  add(modal: any) {
    // add modal to array of active modals
    this.modals.push(modal);
  }

  remove(id: string) {
    // remove modal from array of active modals
    this.modals = this.modals.filter(x => x.id !== id);
  }

  open(id: string) {
    const interval = setInterval(() => {
      const modal = this.modals.find(x => x.id === id);
      
      if (modal) {
        modal.open();
        clearInterval(interval);
      }
    }, 100)
  }

  close(id: string) {
    const interval = setInterval(() => {
      const modal = this.modals.find(x => x.id === id);
      
      if (modal) {
        modal.close();
        clearInterval(interval);
      }
    }, 100)
  }

}
